import { computed } from 'vue-demi';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('quote-rank-v2');

export default (props) => {

    const isCustomRank = computed(() => props.market === 'custom-stock');
    // 热议榜

    const stockIdStr = computed(() => {
        const stockIdList = (props.customStocklist || []).map((stock) => stock.stockId || '');
        return stockIdList.filter((item) => !!item.trim()).join(',');
    });

    // 自定义榜单
    const getCustomRank = async () => {
        const data = {
            stockIds: stockIdStr.value,
            lang: props.language,
            count: props.count
        };
        try {
            return await request.get('get-custom-rank-list', data);
        } catch (err) {
            console.error('custom-rank', err);
        }
    };

    // 热度榜
    const getHotRank = async () => {
        const data = {
            sort_id: props.sort_id,
            market_id: props.market,
            lang: props.language,
            count: props.count,
            platform: props.platform
        };
        try {
            return await request.get('get-rank-list', data);
        } catch (err) {
            console.error('market-rank', err);
        }
    };

    const getRankList = isCustomRank.value ? getCustomRank : getHotRank;

    return {
        getRankList
    };
};
